import { FireRiskEnum } from '../../../../@core/fire-risk-dashboard/domain/enum/FireRisk.enum'
import { FarmFireRiskChartTooltipDto } from '../dtos/FarmFireRiskChartTooltip.dto'
import { FireRiskColorFactory } from '../../../../@core/fire-risk-dashboard/domain/factories/FireRiskColor.factory'
import { RecentFireRisk } from '../../../../@core/fire-risk-dashboard/domain/entities/RecentFireRisk'
import { FireRiskDashboardLabelProvider } from '../providers/FireRiskDashboardLabel.provider'

export class FarmFireRiskChartTooltipFactory {
	static make(farm: RecentFireRisk): FarmFireRiskChartTooltipDto {
		switch (farm.risk) {
			case FireRiskEnum.NONE:
				return {
					color: FireRiskColorFactory.make(farm.risk),
					risk: FireRiskDashboardLabelProvider.risk(farm.risk),
					fmaPlus: farm.fmaPlus,
					dateLabel: FireRiskDashboardLabelProvider.dateAtTime(farm.timestamp),
					farm: farm.monitoredAreaName,
				}
			case FireRiskEnum.NULL:
				return {
					color: FireRiskColorFactory.make(farm.risk),
					risk: FireRiskDashboardLabelProvider.risk(farm.risk),
					fmaPlus: farm.fmaPlus,
					dateLabel: FireRiskDashboardLabelProvider.dateAtTime(farm.timestamp),
					farm: farm.monitoredAreaName,
				}
			case FireRiskEnum.SMALL:
				return {
					color: FireRiskColorFactory.make(farm.risk),
					risk: FireRiskDashboardLabelProvider.risk(farm.risk),
					fmaPlus: farm.fmaPlus,
					dateLabel: FireRiskDashboardLabelProvider.dateAtTime(farm.timestamp),
					farm: farm.monitoredAreaName,
				}
			case FireRiskEnum.MEDIUM:
				return {
					color: FireRiskColorFactory.make(farm.risk),
					risk: FireRiskDashboardLabelProvider.risk(farm.risk),
					fmaPlus: farm.fmaPlus,
					dateLabel: FireRiskDashboardLabelProvider.dateAtTime(farm.timestamp),
					farm: farm.monitoredAreaName,
				}
			case FireRiskEnum.HIGH:
				return {
					color: FireRiskColorFactory.make(farm.risk),
					risk: FireRiskDashboardLabelProvider.risk(farm.risk),
					fmaPlus: farm.fmaPlus,
					dateLabel: FireRiskDashboardLabelProvider.dateAtTime(farm.timestamp),
					farm: farm.monitoredAreaName,
				}
			case FireRiskEnum.HIGHEST:
				return {
					color: FireRiskColorFactory.make(farm.risk),
					risk: FireRiskDashboardLabelProvider.risk(farm.risk),
					fmaPlus: farm.fmaPlus,
					dateLabel: FireRiskDashboardLabelProvider.dateAtTime(farm.timestamp),
					farm: farm.monitoredAreaName,
				}
		}
	}
}
